﻿import React from 'react';

// utils
import IconHelper from '@bazooka_se/lf-icons';

// components
import PossessionsAccordion from './PossessionsAccordion';
import Loader from '../../../UI/Loader';

const PossessionsAccordionContainer = (props) => {

    const current = props.current
    const future = props.future
    const combined = props.combined
    const monthlyPremium = props.monthlyPremium


    // Check to see when data has been fully loaded and when to render loader. If no insurances MonthlyPremium will be 0 and not undefined
    if (monthlyPremium === undefined) {
        return <Loader />;
    }

    return (
        //returns current possessions and/or future possessions in separate PossessionsAccordions
        //returns message if no current or future possessions
        <React.Fragment>     
         
            {current && current.length > 0 &&
                <div className="block-spacing">
                    <h2 className="my-insurance__main-title">Mitt innehav</h2>
                    <div className="my-insurance__hero"><span className="bold">Totalt månadspris:</span> {monthlyPremium} kr</div>
                    <PossessionsAccordion data={current} />
                </div>
            }
            
            {future && future.length > 0 &&
                <React.Fragment>

                    <h2 className="possessions-accordion__future__title">Här visas framtida försäkringar</h2>
                    <p className="possessions-accordion__future__paragraph">Här ser du dina framtida försäkringar</p>
                    <PossessionsAccordion data={future} />
      
                </React.Fragment>
            }

            {combined && combined.length === 0 &&
                <div className="my-insurance__hero__no-insurances">
                    <span dangerouslySetInnerHTML={{ __html: IconHelper('info-circle-line').outerHTML }}></span>
                    <p className="my-insurance__hero__no-insurances__text">Du har inga tecknade försäkringar</p>
                </div>
            }
        </React.Fragment>
    
     )
}

export default PossessionsAccordionContainer;

